import React from 'react';
import ins from '../Images/ins1.jpg';
import snap from '../Images/snap.jpg';

export default function Footer() {
    return (
        <div id="footer" className="myfooter">
            <div className="card">
                <br />
                <div className="card-body">
                    <h3 className="card-title">من نحن</h3>
                    <p className="text">مركز بالي طلاسو للعناية بالرجال</p>
                    <a href="/"><img src={snap} alt="social media" /></a>
                    <a href="/"><img src={ins} alt="social media" /></a>
                </div>
            </div>

            <div className="card">
                <br />
                <div className="card-body">
                    <h3 className="card-title">ساعات العمل</h3>
                    <p className="text">الجمعة : من الساعة 2 بعد الظهر حتى الساعة 3 بعد الفجر</p>
                    <p className="text">باقي الأيام : من الساعة 12 بعد الظهر حتى الساعة 3 بعد الفجر</p>
                </div>
            </div>

            <div className="card">
                <br />
                <div className="card-body">
                    <h3 className="card-title">معلومات الاتصال</h3>
                    <p className="text">العنوان : شارع الأمير ماجد، حي الصفا، جدة 23451، المملكة العربية السعودية</p>
                    <p className="text"><strong>واتساب جدة : </strong> 	
                    00966556838300</p>
                </div>
            </div>

            <div><br /><br />
                <p id='rights'>جميع الحقوق محفوظة © 2025 - مركز بالي طلاسو</p>
                <br />
            </div>
        </div>
    );
}
